import { render, staticRenderFns } from "./TeacherVideo.vue?vue&type=template&id=29d8df2f&scoped=true&"
import script from "./TeacherVideo.vue?vue&type=script&lang=js&"
export * from "./TeacherVideo.vue?vue&type=script&lang=js&"
import style0 from "./TeacherVideo.vue?vue&type=style&index=0&id=29d8df2f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d8df2f",
  null
  
)

export default component.exports